function DealIng() {
  return (
    <div className="flex">
      <div className="bg-cusGray font-bold text-xs w-[60px] h-4 text-center rounded-lg m-1 leading-4">
        거래중
      </div>
    </div>
  );
}

export default DealIng;
